import { useI18n } from "@/contexts/I18nContext";
import { useBranding, resolveLogo } from "@/contexts/BrandingContext";

/** Portal-only header — minimalist. Logo + agency name + language/theme toggles. */
export default function PortalHeader() {
  const { lang, dir, theme, toggleLang, themeName, toggleTheme } = useI18n();
  const { branding } = useBranding();
  const name = "VTA";

  const css = {
    bar: {
      position: "sticky", top: 0, zIndex: 1000, width: "100%",
      background: theme.headerBg, backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      borderBottom: `1px solid ${theme.borderSoft}`,
      fontFamily: "'Tajawal','Segoe UI',sans-serif",
    },
    inner: {
      maxWidth: "1100px", margin: "0 auto", padding: "12px 16px",
      display: "flex", alignItems: "center", gap: "12px",
    },
    brand: { display: "flex", alignItems: "center", gap: "12px", flex: 1, minWidth: 0 },
    logo: { width: "42px", height: "42px", objectFit: "contain", flexShrink: 0 },
    name: {
      fontSize: "14.5px", fontWeight: 800, color: theme.text,
      whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
      letterSpacing: "0.2px",
    },
    iconBtn: {
      width: "38px", height: "38px", borderRadius: "50%",
      background: "transparent", border: `1px solid ${theme.border}`,
      color: theme.text, cursor: "pointer", fontSize: "13px", fontWeight: 700,
      display: "inline-flex", alignItems: "center", justifyContent: "center",
    },
  };

  return (
    <div style={css.bar} dir={dir} data-testid="portal-header">
      <div style={css.inner}>
        <div style={css.brand}>
          <img src={resolveLogo(branding.logo_url)} alt="" style={css.logo} />
          <span style={css.name} data-testid="portal-header-name">{name}</span>
        </div>
        <button onClick={toggleLang} style={css.iconBtn} data-testid="portal-toggle-lang" aria-label="Language">
          {lang === "ar" ? "EN" : lang === "en" ? "اردو" : "AR"}
        </button>
        <button onClick={toggleTheme} style={css.iconBtn} data-testid="portal-toggle-theme" aria-label="Theme">
          {themeName === "dark" ? "☀" : "☾"}
        </button>
      </div>
    </div>
  );
}
